import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Scheduling|Accommodation|Form|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamAccommodations,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateSchedulingAccommodationForm';
export type SPCandidateSchedulingAccommodationFormLocNames =
	| `${LocNameStart}NotificationChangesSaved`
	| `${LocNameStart}LabelExpireDate`
	| `${LocNameStart}LabelLastUpdated`
	| `${LocNameStart}LabelStatus`
	| `${LocNameStart}LabelDescription`
	| `${LocNameStart}LabelDataProviders`
	| `${LocNameStart}LabelNotes`
	| `${LocNameStart}LabelReviewNotes`
	| `${LocNameStart}ErrorExpireDateFuture`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonUpdate`
	| `${LocNameStart}ButtonApprove`
	| `${LocNameStart}ButtonRevoke`
	| `${LocNameStart}ButtonDeny`;

export const spCandidateSchedulingAccommodationFormLocs: LocDefs<SPCandidateSchedulingAccommodationFormLocNames> =
	{
		SPCandidateSchedulingAccommodationFormNotificationChangesSaved: {
			defaultValue: 'Changes saved',
			description: 'Notification message displayed when changes are saved',
			displayPath: `${pathStart}Changes saved`,
			displayType: 'Notification',
			legacyName:
				'Exam.Accommodations/Candidate.Accommodations.NotificationMessage.ChangesSaved',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationFormLabelExpireDate: {
			defaultValue: 'Expire Date',
			description: 'Label for: Expire Date.',
			displayPath: `${pathStart}Expire Date`,
			displayType: 'Label',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.FieldLabel.ExpireDate',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationFormLabelLastUpdated: {
			defaultValue: 'Last Updated',
			description: 'Label for: Last Updated.',
			displayPath: `${pathStart}Last Updated`,
			displayType: 'Label',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.FieldLabel.LastUpdated',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationFormLabelStatus: {
			defaultValue: 'Status',
			description: 'Label for: Status.',
			displayPath: `${pathStart}Status`,
			displayType: 'Label',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.ColumnHeading.Status',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationFormLabelDescription: {
			defaultValue: 'Description',
			description: 'Label for: Description.',
			displayPath: `${pathStart}Description`,
			displayType: 'Label',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.FieldLabel.Description',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationFormLabelDataProviders: {
			defaultValue: 'Data Providers',
			description: 'Label for: Data Providers.',
			displayPath: `${pathStart}Data Providers`,
			displayType: 'Label',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.FieldLabel.DataProviders',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationFormLabelNotes: {
			defaultValue: 'Notes',
			description: 'Label for: Notes.',
			displayPath: `${pathStart}Notes`,
			displayType: 'Label',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.FieldLabel.Notes',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationFormLabelReviewNotes: {
			defaultValue: 'Review Notes',
			description: 'Label for: Review Notes.',
			displayPath: `${pathStart}Review Notes`,
			displayType: 'Label',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.FieldLabel.ReviewNotes',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationFormErrorExpireDateFuture: {
			defaultValue: 'Expire date must be in the future',
			description: 'Error for: Expire date must be in the future.',
			displayPath: `${pathStart}Expire date must be in the future`,
			displayType: 'Error',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.FieldError.ExpireDateMin',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationFormButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel button text',
			displayPath: `${pathStart}Cancel`,
			displayType: 'Button',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.Button.CancelEdit',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationFormButtonUpdate: {
			defaultValue: 'Update',
			description: 'Update button text',
			displayPath: `${pathStart}Update`,
			displayType: 'Button',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.Button.Update',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationFormButtonApprove: {
			defaultValue: 'Approve',
			description: 'Approve button text',
			displayPath: `${pathStart}Approve`,
			displayType: 'Button',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.Button.Approve',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationFormButtonRevoke: {
			defaultValue: 'Revoke',
			description: 'Revoke button text',
			displayPath: `${pathStart}Revoke`,
			displayType: 'Button',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.Button.Revoke',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationFormButtonDeny: {
			defaultValue: 'Deny',
			description: 'Deny button text',
			displayPath: `${pathStart}Deny`,
			displayType: 'Button',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.Button.Deny',
			...sharedProperties,
		},
	};

export type SPCandidateSchedulingAccommodationFormLocType =
	LocMap<SPCandidateSchedulingAccommodationFormLocNames>;
